module.exports = __webpack_public_path__ + "img/sv36.0ed2e9ed.svg";